<template>
  <n-dialog
    v-model="dialog" 
    :width="500"
    class="container text-center"
  > 
    <v-card> 
      <v-card-title 
        primary-title                              
      > 
        <v-col
          cols="10"
          class="pa-0"
        >
          <h3>ถอนโบนัสเงินคืน</h3>
          <b class="red--text minimum-withdraw">
            {{ $t('minimum-withdraw') }} {{ userProfile.credit_request_condition.min_cashback_amount }} {{ $t('unit.baht') }}
          </b>
        </v-col>
        <v-spacer /> 
        <v-icon @click="closeDialog()">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-divider />
      <div>
        <div class="mt-1 py-3 mx-3 ">
          <v-row
            no-gutters
            class="mx-1"
          >
            <v-col>
              <h4>ยอดโบนัสที่ถอนได้</h4>
            </v-col>
            <v-col class="text-end max-withdraw">
              {{ withdrawAmount | currency }}
            </v-col>
          </v-row>
        </div>
        <v-row
          no-gutters
          class="py-5"
        >
          <v-col
            v-for="temp in selectTabAmount"
            :key="temp"  
            class="d-flex justify-center"
          >
            <v-btn-toggle
              v-model="selectAmount" 
              color="var(--bg-secondary-color)"
            >
              <v-btn
                class="force-round" 
                :value="temp"
                @click="GA('SelectAmount',temp)"
              >
                {{ temp }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <div class="px-5">
          <h4>{{ $t('fill-amount') }}</h4>
          <n-number-field-specific
            v-model="selectAmount"
            class="mt-2"
            prevent-paste
            :suffix="$t('unit.baht')"
            :error-messages="selectAmounterrors"
            :placeholder="$t('placeholder.fill-amount')"
          />
        </div>
      </div>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn 
              class="white--text"
              color="#6450FE"
              depressed
              block
              :disabled="submitStatus"
              :loading="submitStatus"
              @click="submit"
            >
              <div class="flex justify-center items-center gap-1">
                <span>{{ $t('button.withdraw') }}</span>
                <div>
                  <v-img
                    width="16"
                    src="@/assets/cashback2/cash.png"
                  />
                </div>
              </div>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="white--text mt-2"
              color="red"
              depressed
              block
              @click="cancelDialog"
            >
              <div class="flex justify-center items-center gap-1">
                <span>{{ $t('button.cancel') }}</span>
                <div>
                  <v-img
                    width="16"
                    src="@/assets/cashback2/close.png"
                  />
                </div>
              </div>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </n-dialog>
</template>
<script> 
import { validationMixin } from 'vuelidate'
import { required} from 'vuelidate/lib/validators'
import { credits as apiCredits } from '@/apis'  

export default {
  mixins: [validationMixin],
  validations:{
    selectAmount:{required}, 
  },
  data: () => ({
    dialog:false,  
    selectAmount:'',
    selectTabAmount:['20','50','100','200','500'],   
    submitStatus:false,
    withdrawAmount : 0
  }),  
  computed : {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    selectAmounterrors (){
      const errors = []
      if (!this.$v.selectAmount.$dirty) return errors
      !this.$v.selectAmount.required && errors.push(this.$t('validate.please-enter-number'))
      if(parseInt(this.withdrawAmount)-parseInt(this.selectAmount)<0)
      { 
      errors.push(this.$t('validate.money-not-enough')) 
      return errors
      }
      if(parseInt(this.selectAmount)<this.userProfile.credit_request_condition.min_cashback_amount){ 
      errors.push(`${this.$t('validate.minimum-amount-can-withdraw-is')} ${this.userProfile.credit_request_condition.min_cashback_amount} ${this.$t('unit.baht')}`) 
      return errors
      } 
      if(parseInt(this.selectAmount)>this.userProfile.credit_request_condition.max_cashback_amount){ 
      errors.push(`${this.$t('validate.maximum-amount-can-withdraw-is')} ${this.userProfile.credit_request_condition.max_cashback_amount} ${this.$t('unit.baht')}`) 
      return errors
      } 
      return errors 
    }, 
  },
  methods : { 
    GA (actions,value) {
        this.$ga.event('Button', actions, 'AffiliatePage',value )
    }, 
    async submit () {  
      this.$v.selectAmount.$touch() 
      if(
        this.selectAmount &&
        parseInt(this.withdrawAmount)-parseInt(this.selectAmount)>=0 &&
        parseInt(this.selectAmount)>=this.userProfile.credit_request_condition.min_cashback_amount &&
        parseInt(this.selectAmount)<=this.userProfile.credit_request_condition.max_cashback_amount
      ){ 
        this.withdrawApi()
      } 
    }, 
    async withdrawApi () {
      let params = {
        request_amount : this.selectAmount
      }
      const [err,,message] = await apiCredits.withdrawCashback(params)
       
      if(err) {
        this.submitstatus = !this.submitstatus
        this.$alert('',err,'warning')  
        return
      }

      this.selectAmount = null
      this.$store.dispatch('userProfile/ACTION_WALLET')
      this.$alert('', message, 'success')
      this.$emit('success')

      setTimeout(() => {
        this.$emit('success')
      }, 3000)

      this.dialog = false 
    },
    
    closeDialog () {
      this.$ga.event('Button', 'CloseWithdrawCashBackDialog', 'AffiliatePage','' )
      this.dialog=false
    }, 

    cancelDialog () {
      this.$ga.event('Button', 'CancelWithdrawCashBackDialog', 'AffiliatePage','' )
      this.dialog=false
    },  

    open (amount) { 
      this.withdrawAmount = amount
      this.selectAmount = ''
      this.dialog = true
    }
  }
}
</script>
<style>
.minimum-withdraw {
  font-size: 0.9rem;
}

.max-withdraw {
  color: #6450FE;
}
</style>